import React from 'react';
import { Link, useLocation} from 'react-router-dom';
import _ from 'lodash';
import qs from 'qs';
import './index.scss';
import { BsChevronDown as ChevronDownIcon } from 'react-icons/bs';
import { ReactComponent as NewRelicIcon } from 'icons/NewRelic.svg';
import { ReactComponent as StackdriverIcon } from 'icons/stackdriver.svg';
import { ReactComponent as CloudwatchIcon } from 'icons/aws-cloudwatch.svg';
import { ReactComponent as AWSIcon } from 'icons/aws.svg';
import { ReactComponent as DatadogIcon } from 'icons/dd_logo_v_rgb.svg';
import { ReactComponent as AzureIcon } from 'icons/azure.svg';
import { ReactComponent as KubernetesIcon } from 'icons/kubernetes.svg';
import { ReactComponent as RackspaceIcon } from 'icons/rackspace-r.svg';
import { ReactComponent as VMWareIcon } from 'icons/vmware_logo.svg';
import { BsQuestionCircleFill as UnknownIcon } from 'react-icons/bs';

import { translations } from '@janus.team/janus-particles';
import { useCurrentAccount } from 'account-selector';
import { useWebhooksForAccountQuery } from 'api/watchman';

import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';

export const MonitoringSelector = () => {
  const t = translations.useT();
  const { pathname } = useLocation();
  const dataSources = useDataSources();
  const selected = useCurrentDataSource();
  const search = qs.parse(useLocation()?.search || '', { ignoreQueryPrefix: true });
  
  return (
    <div className="account-select container-xxl container-fluid">  
      <h2 className="my-6">{t('Monitoring Service')}</h2>
      <Dropdown className="mb-10">
        <Dropdown.Toggle as={Button} variant="outline border" className="w-100" >
          <div className="d-flex justify-content-between align-items-center">
            {selected ? (
              <MonitoringService dataSourceItem={selected} style={{maxWidth: '75%'}}/>
            ) : (
              t('Choose Monitoring Service')
            )}
            <ChevronDownIcon className="text-gray700" style={{width: '1.5rem'}}/>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100 shadow">
          {_.map(dataSources, (dataSourceItem, index) => {
            const id = `select-data-source-${index}`;
            const toSearch = qs.stringify(_.merge({}, search, { dataSource: dataSourceItem?.type }));
            return (
              <Dropdown.Item
                key={id}
                as={Link}
                to={{ pathname, search: toSearch }}
                disabled={!dataSourceItem.enabled}
              >
                <MonitoringService dataSourceItem={dataSourceItem}/>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

const MonitoringService = ({dataSourceItem, ...props}) => {
  const t = translations.useT();
  return (
    <div className="d-flex gap-6 align-items-center" {...props}>
      <IconOf id={dataSourceItem?.name} label={dataSourceItem?.name}/>
      <div className="text-start text-truncate" >
        <div>{t(dataSourceItem?.name)}</div>
        <small className="d-block text-muted text-truncate"></small>
      </div>
    </div>
  );
};

const useDataSources = () => {
  const { tenantId } = useCurrentAccount() || {};
  const latestWebhooks = useWebhooksForAccountQuery(tenantId)?.data;
  const dataSources = _.filter(_.uniqBy(latestWebhooks, 'type'), { enabled: true });
  // const [dataSources, setDataSources] = React.useState(latestDataSources || []);
  // React.useEffect(() => { setDataSources(latestDataSources); }, [latestDataSources, setDataSources]);
  return dataSources;
};

const IconOf = ({ id, label }) => {
  const t = translations.useT();
  const IconComponent = _.get({
    NEW_RELIC: NewRelicIcon,
    DATADOG: DatadogIcon,
    CLOUDWATCH: CloudwatchIcon,
    STACKDRIVER: StackdriverIcon,
    AZURE: AzureIcon,
    AZURE_EVENTS: AzureIcon,
    AZURE_LOG_ALERTS_V_2_COMMON_SCHEMA: AzureIcon,
    AZURE_APPLICATION_INSIGHTS: AzureIcon,
    AZURE_PROMETHEUS_ALERTS: AzureIcon,
    AZURE_LOG_ANALYTICS: AzureIcon,
    AZURE_V_MWARE_V_CENTER: AzureIcon,
    AZURE_METRIC_ALERTS: AzureIcon,
    ALERT_MANAGER: KubernetesIcon,
    BACKUP: AWSIcon,
    MAINTENANCE_WINDOW: RackspaceIcon,
    RDS: AWSIcon,
    SSM: AWSIcon,
    APS: RackspaceIcon,
    EVENT_BRIDGE: AWSIcon,
    V_MWARE_V_CENTER: VMWareIcon
  }, _.toUpper(_.snakeCase(id)), UnknownIcon);
  return <IconComponent className="monitoring-service-icon" title={t(label)} />;
};

export const useCurrentDataSource = () => {
  const dataSources = useDataSources();
  const parsedQuery = qs.parse(useLocation()?.search || '', { ignoreQueryPrefix: true }) || {};
  const { dataSource } = parsedQuery || {};
  return _.find(dataSources, { type: dataSource });
};

export default MonitoringSelector;